const Rap = {
  symbol: 'rap',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM12.478 6.435V6H9v19.913h3.478V6.435zM14.957 6H15v3.217h1.522c2.217 0 3.608 1 3.608 2.957 0 1.956-1.39 2.956-3.608 2.956h-3.348l6.956 10.783h4.087l-5.087-7.74c2.913-.738 4.522-3 4.522-5.956C23.652 8.565 20.957 6 16.913 6h-1.956z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#000"/><path d="M12.478 6.435v19.478H9V6h3.478v.435zM14.957 6h1.956c4.044 0 6.74 2.565 6.74 6.217 0 2.957-1.61 5.218-4.523 5.957l5.087 7.739H20.13L13.174 15.13h3.348c2.217 0 3.608-1 3.608-2.956 0-1.957-1.39-2.957-3.608-2.957H15V6h-.043z" fill="#FFF"/></g>`;
  }
};
export default Rap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/rap.js
// module id = null
// module chunks = 